import { render, staticRenderFns } from "./SortArrows.vue?vue&type=template&id=4eebf526"
import script from "./SortArrows.vue?vue&type=script&lang=js"
export * from "./SortArrows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports